module.exports = __webpack_public_path__ + "img/book2.c719f1fb.webp";